import React from "react";
import LoadingSkeleton from "../general/skeleton";
import Grid from "../general/grid";

export const GridCard = ({ title, description, loading, children, actions = [] }) => {
  return (
    <LoadingSkeleton loading={loading} className={"h-[120px]"} width={800}>
      <div className="h-full bg-white flex-1 relative px-3 py-2 rounded-2xl font-nexa flex flex-col justify-between">
        {/* Header with title and actions */}
        <div className="flex justify-between items-center">
          <h2 className="font-nexa text-lg text-primary-dark leading-6 m-0">{title}</h2>
          
          {/* Render actions as buttons or custom components */}
          {actions.length > 0 && (
            <div className="flex gap-2">
              {actions.map((action, index) => 
                typeof action === "object" && action.label && action.onClick ? (
                  <button 
                    key={index}
                    onClick={action.onClick}
                    className="bg-primary-title text-white px-3 py-2 rounded-md text-sm hover:bg-primary-dark transition-all text-left"
                  >
                    {action.label}
                  </button>
                ) : (
                  <div key={index}>{action}</div> // Renders custom React components
                )
              )}
            </div>
          )}
        </div>

        <p className="font-nexa text-sm text-primary-title leading-10 m-0">{description}</p>

        <div className="w-full pb-2">
          <Grid numCols={2}>{children}</Grid>
        </div>
      </div>
    </LoadingSkeleton>
  );
};
